import { Link } from 'react-router-dom';

export default function FAQSection() {
  const faqs = [
    {
      q: 'What is AllChinaBuySpreadsheet used for?',
      a: 'AllChinaBuySpreadsheet is used for discovering profitable products from Chinese suppliers through organized, pre-vetted spreadsheet data. It helps ecommerce sellers on Shopify, Amazon, TikTok Shop, and other platforms find winning products faster without manually searching through supplier platforms.',
    },
    {
      q: 'Is AllChinaBuySpreadsheet free?',
      a: 'The AllChinaBuySpreadsheet is updated weekly with fresh product data, trending items, and supplier insights. Access to the full spreadsheet is available through our main platform at KASpreadsheet.com, where different subscription tiers offer varying levels of data depth and update frequency.',
    },
    {
      q: 'How often is the AllChinaBuySpreadsheet updated?',
      a: 'We update the spreadsheet every week with new trending products, refreshed pricing data, and supplier verification notes. This ensures you always have access to current market information and can spot emerging trends before competitors.',
    },
    {
      q: 'Can beginners use the AllChinaBuySpreadsheet effectively?',
      a: 'Absolutely. The spreadsheet is designed with beginners in mind — products are organized by category, with clear pricing, supplier ratings, and trend indicators. No prior sourcing experience is needed. Many first-time sellers have successfully launched stores using our data.',
    },
    {
      q: 'Is AllChinaBuySpreadsheet better than Alibaba sourcing?',
      a: 'They serve different purposes. Alibaba requires manual searching and supplier vetting, which is time-consuming. The AllChinaBuySpreadsheet gives you structured, curated data in one place — it complements Alibaba sourcing by pre-filtering and organizing the best opportunities so you can focus on scaling rather than searching.',
    },
    {
      q: 'What types of products are included in the spreadsheet?',
      a: 'The spreadsheet covers 30+ categories including shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes, and more. Each category includes trending items, price ranges, supplier quality ratings, and estimated profit margins.',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.a,
      },
    })),
  };

  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-background-50" id="faq">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed">
            Everything you need to know about the AllChinaBuySpreadsheet and how it helps
            ecommerce sellers find winning products.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group border border-background-200/70 rounded-xl bg-background-100">
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-950 pr-4">
                  {faq.q}
                </h4>
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 group-open:bg-accent-100 transition-colors">
                  <i className="ri-add-line text-foreground-600 group-open:hidden"></i>
                  <i className="ri-subtract-line text-accent-600 hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/allchinabuyspreadsheet-complete-guide-2026"
            className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
          >
            Read Our Complete AllChinaBuySpreadsheet Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}